module.exports = __webpack_public_path__ + "static/img/logo.1948a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 250